import { List } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StripedList = styled(List)(({ theme }) => ({
  '& .MuiListItem-root:nth-of-type(even)': { backgroundColor: 'rgba(0, 0, 0, 0.02)' },
  '& .MuiListItem-root:hover': { backgroundColor: theme.palette.action.hover },
  '& .MuiListItem-root:nth-of-type(even):hover': { backgroundColor: 'rgba(0, 0, 0, 0.06)' },
}));
